import React from 'react';
import { Flex } from '@chakra-ui/react';
import sdgSprite from '../images/sdg-sprite.png';

type SdgImageContainerProps = {
  bgPosition: string;
  bgSize: string;
  imgWidth: string;
  imgHeight: string;
  relevanceType?: string;
};

export const SdgImageContainer = ({
  bgPosition,
  bgSize,
  imgWidth,
  imgHeight,
  relevanceType,
}: SdgImageContainerProps) => (
  <Flex
    bgImage={`url('${sdgSprite}')`}
    bgPosition={bgPosition}
    bgSize={bgSize}
    bgRepeat="no-repeat"
    w={imgWidth}
    h={imgHeight}
    minW={imgWidth}
    opacity={relevanceType && relevanceType === 'skipped' ? 0.1 : 1}
  />
);
